import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { CartProvider } from './cart.jsx';
import { reportClientError } from './reportError.js';
import './styles.css';

// Red de seguridad (2026-07-21): hay un fallo detectado SOLO en Chrome (interno
// de react-dom, aún sin causa raíz confirmada) que deja la app desmontada — sin
// esto, la única forma de recuperarse es que la persona refresque a mano. Aquí
// se recarga sola, limitando a como mucho 1 recarga cada 4s para no entrar en
// bucle si el fallo fuese inmediato y determinista en la carga.
const AUTO_RELOAD_KEY = 'kanel-auto-reload-ts';
function maybeAutoReload() {
  const last = Number(sessionStorage.getItem(AUTO_RELOAD_KEY) || 0);
  const now = Date.now();
  if (now - last > 4000) {
    sessionStorage.setItem(AUTO_RELOAD_KEY, String(now));
    window.location.reload();
  }
}

window.addEventListener('error', (e) => {
  reportClientError({ kind: 'window.error', message: e.message, stack: e.error?.stack || '' });
  maybeAutoReload();
});
window.addEventListener('unhandledrejection', (e) => {
  reportClientError({ kind: 'unhandledrejection', message: String(e.reason?.message || e.reason || ''), stack: e.reason?.stack || '' });
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <CartProvider>
        <App />
      </CartProvider>
    </BrowserRouter>
  </React.StrictMode>
);
